import CardTotal from "../../Component/home/CardTotal";
import ChartComponent from "../../Component/home/ChartComponent";
import OrdersCard from "../../Component/home/OrdersCard";
import RecentContacts from "../../Component/home/RecentContacts";
import OrderReports from "../../Component/home/OrderReports";
import { useEffect, useState } from "react";
import apiRequests from "../../Component/axios/config/config";
import toast from "react-hot-toast";
import LoadingSpan from "../../Component/Loading/LoadingSpan";

export default function Home() {
  const [loading, setLoading] = useState(false);
  const [dashData, setDashData] = useState({});
  const dashboardData = async () => {
    setLoading(true);
    try {
      const res = await apiRequests.get("/seller/v1/dashbouard");
      setDashData(res.data.data);
      console.log(res.data.data);
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    dashboardData();
  }, []);

  if (loading) {
    return (
      <div className="w-full h-[90%] flex justify-center items-center">
        <div className="flex items-center gap-1">
          <p className="pt-2 text-xl">Loading</p>
          <LoadingSpan />
        </div>
      </div>
    );
  }
  return (
    <>
      <main className="flex flex-col gap-5 p-10 justify-center">
        <section className="grid grid-cols-3 gap-x-6 md:grid-cols-2 md:gap-y-8 sm:grid-cols-1">
          <CardTotal
            type={1}
            title="New orders"
            number={dashData.pendingOrders}
            explaination="pending orders"
          />
          <CardTotal
            type={2}
            title="Active orders"
            number={dashData.acceptedOrders}
            explaination="Total"
          />
          <CardTotal
            type={3}
            title="Products"
            number={dashData.products}
            explaination=""
          />
        </section>
        <section className="w-full grid grid-cols-12 gap-x-6 md:grid-cols-1 md:gap-4">
          <OrdersCard dashData={dashData} />
          <ChartComponent />
        </section>
        {/*<section className="w-full grid grid-cols-12 gap-6 mt-6">*/}
        {/*  <RecentContacts />*/}
        {/*  <OrderReports />*/}
        {/*</section>*/}
      </main>
    </>
  );
}
